import validate from './AddChildPopupFormValidation';

import UseForm from "@usas/ui-web/utils/UseForm";

const INITIAL_FORM_STATE = {
  memberId: '',
  matchedMember: {}
};

const useAddChildPopupForm = (onSubmitFormCallback) => {
  const { formState, errorState, isSubmitting, updateFormState, handleSubmit
  } = UseForm(INITIAL_FORM_STATE, onSubmitFormCallback, validate);

  return {
    isLoading: isSubmitting,
    formState,
    errorState,
    onFormValueChanged: updateFormState,
    handleSubmit
  };
};

export default useAddChildPopupForm;